<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-阶段-修改
    -->
    <el-dialog
    title="修改阶段"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">修改阶段</div>

        <el-form-item label="阶段名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入阶段名称" class="max-w460"></el-input>
        </el-form-item>

        <!-- 上传视频 -->
        <el-form-item label="上传视频">
          <div class="video-upload-wrapper">
            <!-- 视频预览 -->
            <div v-if="form.video_url" class="video-preview">
              <video :src="form.video_url" controls class="video-player"></video>
              <div class="video-info">
                <span class="video-name">{{ form.video_name || '视频文件' }}</span>
                <el-button type="text" @click="removeVideo" class="delete-btn">删除</el-button>
              </div>
            </div>
            
            <!-- 上传按钮 -->
            <el-button 
              v-else
              @click="openVideoUpload" 
              icon="el-icon-video-camera" 
              type="primary"
              class="upload-btn"
            >
              上传视频
            </el-button>
            
            <div class="upload-tips">
              <p>支持格式：mp4, avi, mov, wmv 等常见视频格式</p>
              <p>建议视频大小不超过500MB</p>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="排序" prop="sort">
          <el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input>
        </el-form-item>
       
    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>

    <!-- 图片上传组件 -->
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
    
    <!-- 视频上传组件 -->
    <Upload 
      v-if="isVideoUpload" 
      :config="{ 
        total: 1, 
        fileType: 'video',
        accept: 'video/*',
      }" 
      :isupload="isVideoUpload" 
      @returnImgs="returnVideoFunc"
    >
      上传视频
    </Upload>
  </div>
</el-dialog>
</template>

<script>
import Stage_stageApi from '@/api/stage_stage.js';
import Upload from '@/components/file/Upload';
import draggable from "vuedraggable";
export default {
  components: {
    Upload: Upload,
    draggable,
  },
  data() {
    return {
      /*是否上传图片*/
      isupload: false,
      isImg: false,  
      /*是否上传视频*/
      isVideoUpload: false,
      /*form表单数据*/
      form: {
        studymenu_id: '',
        name: '',
        code: 'custom',
        sort: 50,
        video_url: '', // 视频URL
        video_name: '', // 视频文件名
        video_id: '', // 视频文件ID
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入阶段名称', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
      },
      jzList: [],
      dialogVisible: false,
      iscategorya: false,
      excludeIds: [],
      isProductUpload: false,
      code: "album"
    };
  },
  created() {
    this.dialogVisible = this.open_add;
    this.getDetail();
    this.getJzList();
  },
  props: ["open_add","stage_stage_id"],
  methods: {
    getJzList() {
      Stage_stageApi.getJzList().then(res => {
        this.jzList = res.data.data;
      });
    },

    /*打开视频上传*/
    openVideoUpload() {
      this.isVideoUpload = true;
    },

    /*处理视频上传结果*/
    returnVideoFunc(e) {
      if (e && e.length > 0) {
        const videoFile = e[0];
        this.form.video_url = videoFile.file_path;
        this.form.video_name = videoFile.real_name || videoFile.file_name;
        this.form.video_id = videoFile.file_id;
      }
      this.isVideoUpload = false;
    },

    /*删除视频*/
    removeVideo() {
      this.form.video_url = '';
      this.form.video_name = '';
      this.form.video_id = '';
    },

    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", {});
    },

    cancelFunc() {
      this.dialogFormVisible("error");
    },

    getDetail() {
      let self = this;
      Stage_stageApi.detail({stage_stage_id: self.stage_stage_id}, true)
        .then(res => {
          self.form = {
            ...res.data,
            // 确保视频相关字段存在
            video_url: res.data.video_url || '',
            video_name: res.data.video_name || '',
            video_id: res.data.video_id || '',
          };
          self.isImg = true;
          self.loading = false;
        })
        .catch(error => {});
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Stage_stageApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error");
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消修改，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false, "type": "" });
    },

    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code;
    },
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

/* 视频上传样式 */
.video-upload-wrapper {
  width: 100%;
}

.video-preview {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 10px;
  background: #f9f9f9;
}

.video-player {
  width: 100%;
  max-width: 400px;
  height: 200px;
  border-radius: 4px;
  background: #000;
}

.video-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  padding: 0 10px;
}

.video-name {
  color: #666;
  font-size: 14px;
}

.delete-btn {
  color: #f56c6c;
}

.upload-btn {
  margin-bottom: 10px;
}

.upload-tips {
  margin-top: 10px;
}

.upload-tips p {
  margin: 2px 0;
  font-size: 12px;
  color: #999;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/course_course/stage/part/edit.vue